import { ColumnFilter } from './types'
import { hasActiveFilterValue, isDateRangeFilterValue } from './filterUtils'

export const appendColumnFiltersToParams = (
  params: URLSearchParams,
  columnFilters: ColumnFilter[],
  mapFieldForApi: (field?: string) => string
) => {
  columnFilters.forEach((filter) => {
    if (!hasActiveFilterValue(filter.value)) return

    // Synthetic/UI-only fields are filtered on client-side.
    if (filter.field === 'link_actions') {
      return
    }

    if (filter.field === 'linking_status') {
      const valStr = String(filter.value).toLowerCase().trim()
      let mappedValue = filter.value
      if (filter.value === true || valStr === 'true' || valStr === 'linked') {
        mappedValue = 'True'
      } else if (filter.value === false || valStr === 'false' || valStr === 'unlinked') {
        mappedValue = 'False'
      } else if (typeof filter.value === 'string' && filter.value.trim() !== '') {
        mappedValue = filter.value.toUpperCase()
      }
      params.append('linking_status', String(mappedValue))
      if (filter.operator) {
        params.append('linking_status_operator', filter.operator)
      }
      return
    }

    const apiField = mapFieldForApi(filter.field)
    const mappedField = apiField === 'sync_status' ? 'primary_sync_status' : apiField

    if (isDateRangeFilterValue(filter.value)) {
      if (filter.value.from) {
        params.append(`${mappedField}_from`, filter.value.from)
      }
      if (filter.value.to) {
        params.append(`${mappedField}_to`, filter.value.to)
      }
      return
    }

    const mappedValue =
      typeof filter.value === 'string' && filter.value === 'SYNCED' ? 'LINKED' : filter.value

    params.append(mappedField, String(mappedValue))

    if (filter.operator) {
      params.append(`${mappedField}_operator`, filter.operator)
    }
  })
}
